// Single source of truth for the public demo experience.
// Read both server- and client-side; inlined at build time by Next.js so
// the entire demo surface (page, UI, credentials) is tree-shaken out of
// buyer client bundles when the flag is not set to "on".
export const DEMO_MODE_ENABLED = process.env.NEXT_PUBLIC_DEMO_MODE === 'on';

export const DEMO_OWNER_EMAIL = 'demo@voiceguest.com';
export const DEMO_OWNER_PASSWORD = 'demo123456';

// The public superadmin demo has been retired — VoiceGuest is sold to
// restaurant clients, so no platform-admin demo is exposed. This address is
// retained ONLY so the read-only demo guard (server/middleware/withAuth.ts and
// client/hooks/useIsDemoSession.ts) keeps treating it as a locked-down demo
// identity if it ever appears in a session. It is never seeded, auto-logged in,
// or surfaced as public credentials.
export const DEMO_ADMIN_EMAIL = 'admin@voiceguest.com';
